import { AnnouncementDetailPage } from '@/components/announcements/announcement-detail-page'

export function AdminAnnouncementDetail() {
  return <AnnouncementDetailPage basePath="/admin/announcements" />
}
